import React, { useState, useEffect } from "react";
import { v4 as uuidv4 } from "uuid";
import { Box, Button, Typography, IconButton, Paper } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { toast } from "react-toastify";

const DeviceRegister = () => {
  const [uuid, setUuid] = useState("");
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    const existingUUID = localStorage.getItem("UULIMS");
    if (existingUUID) {
      setUuid(existingUUID);
      setCopied(true); 
    }
  }, []);

  // If UUID exists and was copied, hide the whole component
  if (uuid && copied) {
    return null;
  }

  const handleGenerateUUID = () => {
    const newUUID = uuidv4();
    setUuid(newUUID);
    localStorage.setItem("UULIMS", newUUID);
  };

  const handleCopy = () => {
    navigator.clipboard
      .writeText(uuid)
      .then(() => {
        toast.success("Register ID copied to clipboard!", {
          position: "top-center",
          autoClose: 3000,
          theme: "light",
        });
        setCopied(true); // Hide component after copy
        setTimeout(() => {
          window.location.reload();
        }, 700);
      })
      .catch(() => alert("Failed to copy UUID"));
  };

  return (
    <Box
      mt={2}
      display="flex"
      flexDirection="column"
      alignItems="center"
      gap={2}
    >
      {!uuid ? (
        <Button
          variant="contained"
          onClick={handleGenerateUUID}
          sx={{
            backgroundColor: "#0A66C2",
            borderRadius: "100px",
            color: "#fff",
            fontWeight: 600,
            fontSize: "13px",
            minHeight: "40px",
            paddingX: "17px",
            textTransform: "none",
            "&:hover": {
              backgroundColor: "#16437E",
            },
          }}
        >
          Register Device
        </Button>
      ) : (
        <Typography
          variant="body1"
          sx={{
            fontWeight: 600,
            color: "#0A66C2",
          }}
        >
          Send This Register ID To BFI Team
        </Typography>
      )}

      {uuid && (
        <Paper
          elevation={1}
          sx={{
            p: 1,
            display: "flex",
            alignItems: "center",
            maxWidth: 400,
            width: "100%",
            backgroundColor: "transparent",
            borderRadius: 2,
            boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
          }}
        >
          <Typography
            variant="body2"
            sx={{
              wordBreak: "break-word",
              flexGrow: 1,
              fontSize: "0.7rem",
              color: "#333",
              userSelect: "text",
            }}
          >
            {uuid}
          </Typography>
          <IconButton
            color="primary"
            onClick={handleCopy}
            size="small"
            aria-label="Copy UUID"
            sx={{
              ml: 1,
              "&:hover": {
                color: "#0A66C2",
                backgroundColor: "rgba(10, 102, 194, 0.1)",
              },
            }}
          >
            <ContentCopyIcon fontSize="small" />
          </IconButton>
        </Paper>
      )}
    </Box>
  );
};

export default DeviceRegister;
